// extracted by mini-css-extract-plugin
export var buttonContainer = "_5t-1";
export var fontSizeSelect = "_5t-3";
export var formatSelect = "_5t-2";
export var formats = "_5t-4";
export var hidden = "_5t-5";
export var icon = "_5t-6";
export var select = "_5t-0";